import { TypesenseLot } from '@bonhams1793/bonhams-typescript'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

import { getTypesenseLots } from '@web/helpers/api/typesense'

export function useGetSimilarLots({
  lotDepartmentCode,
  enabled = true,
}: {
  lotDepartmentCode?: string
  enabled?: boolean
}): UseGetSimilarLotsProps {
  const { data, error, isSuccess, isFetching, isError } = useQuery({
    queryKey: ['similarLots', lotDepartmentCode],
    queryFn: async () => {
      const similarLots = await getTypesenseLots({
        chronology: 'future',
        departmentCode: lotDepartmentCode ? [lotDepartmentCode] : [],
        isToBeSold: true,
        excludeWithdrawn: true,
        per_page: 24,
      })

      return similarLots.hits.map((lot) => lot)
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    retryOnMount: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled,
  })

  return {
    data: data ?? [],
    isSuccess,
    isFetching,
    isError,
    error,
  }
}

export interface UseGetSimilarLotsProps
  extends Pick<UseQueryResult, 'isSuccess' | 'isFetching' | 'isError'> {
  data: TypesenseLot[]
  error: Error | null
}
